document.addEventListener('keydown', (event) => {
 if (event.key !== 'Escape') return;
 document.querySelectorAll('.header details[open]').forEach((el) => {el.open = false; el.querySelector('summary').focus();});
});
document.addEventListener('click', (event) => {
 document.querySelectorAll('.header details[open]').forEach((el) => {if (!el.contains(event.target)) el.open = false;});
});
